import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class PrintNode_ds_get_printjobsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { printJobId?: number, printerId?: number, $top?: number, $skip?: number }): Promise<{ result?: { id?: number, source?: string, title?: string, state?: string }[], totalCount?: number }> {
    let url = `${environment.backendUrl}api/PrintNode/datasources/ds_get_printjobs/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { printJobId?: number, printerId?: number, $keys: number[] }): Promise<{ result?: { id?: number, source?: string, title?: string, state?: string }[] }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/PrintNode/datasources/ds_get_printjobs/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      printJobId?: number, printerId?: number    }) {
      return false;
    }
}
